export default "https://cdn.questicon.mathletics.com/assets/images/logo_mathletics-5b8ddfbac70e2004f0140295b9baf881.svg";